import _extends from "@babel/runtime/helpers/extends";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Menu, Icon } from '@cainiaofe/cn-ui';
import { obj, func, KEYCODE } from "../../utils";
var pickOthers = obj.pickOthers;
var bindCtx = func.bindCtx;
var CascaderMenuItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CascaderMenuItem, _Component);
  function CascaderMenuItem(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      loading: false
    };
    bindCtx(_assertThisInitialized(_this), ['handleExpand', 'handleClick', 'handleMouseEnter', 'handleKeyDown', 'removeLoading']);
    return _this;
  }
  var _proto = CascaderMenuItem.prototype;
  _proto.addLoading = function addLoading() {
    this.setState({
      loading: true
    });
  };
  _proto.removeLoading = function removeLoading() {
    this.setState({
      loading: false
    });
  };
  _proto.setLoadingIfNeed = function setLoadingIfNeed(p) {
    if (p && typeof p.then === 'function') {
      this.addLoading();
      p.then(this.removeLoading)["catch"](this.removeLoading);
    }
  };
  _proto.handleExpand = function handleExpand(focusedFirstChild) {
    this.setLoadingIfNeed(this.props.onExpand(focusedFirstChild));
  };
  _proto.handleClick = function handleClick() {
    this.handleExpand(false);
  };
  _proto.handleMouseEnter = function handleMouseEnter() {
    this.handleExpand(false);
  };
  _proto.handleKeyDown = function handleKeyDown(e) {
    if (!this.props.disabled) {
      if (e.keyCode === KEYCODE.RIGHT || e.keyCode === KEYCODE.ENTER) {
        if (this.props.canExpand) {
          this.handleExpand(true);
        }
      } else if (e.keyCode === KEYCODE.LEFT || e.keyCode === KEYCODE.ESC) {
        this.props.onFold();
      } else if (e.keyCode === KEYCODE.SPACE) {
        this.handleExpand(false);
      }
    }
  };
  _proto.render = function render() {
    var _cx;
    var _this$props = this.props,
      prefix = _this$props.prefix,
      className = _this$props.className,
      menu = _this$props.menu,
      disabled = _this$props.disabled,
      selected = _this$props.selected,
      onSelect = _this$props.onSelect,
      expanded = _this$props.expanded,
      canExpand = _this$props.canExpand,
      expandTriggerType = _this$props.expandTriggerType,
      checkable = _this$props.checkable,
      checked = _this$props.checked,
      indeterminate = _this$props.indeterminate,
      checkboxDisabled = _this$props.checkboxDisabled,
      onCheck = _this$props.onCheck,
      children = _this$props.children;
    var others = pickOthers(Object.keys(CascaderMenuItem.propTypes), this.props);
    var loading = this.state.loading;
    var itemProps = _extends({
      className: cx((_cx = {}, _cx[prefix + "cascader-menu-item"] = true, _cx[prefix + "expanded"] = expanded, _cx[className] = !!className, _cx)),
      disabled: disabled,
      menu: menu,
      onKeyDown: this.handleKeyDown,
      role: 'option'
    }, others);
    if (!disabled) {
      if (expandTriggerType === 'hover') {
        itemProps.onMouseEnter = this.handleMouseEnter;
      } else {
        itemProps.onClick = this.handleClick;
      }
    }
    var Item, title;
    if (checkable) {
      Item = Menu.CheckboxItem;
      itemProps.checked = checked;
      itemProps.indeterminate = indeterminate;
      itemProps.checkboxDisabled = checkboxDisabled;
      itemProps.onChange = onCheck;
    } else {
      Item = Menu.Item;
      itemProps.selected = selected;
      itemProps.onSelect = onSelect;
    }
    if (typeof children === 'string') {
      title = children;
    }
    return /*#__PURE__*/React.createElement(Item, _extends({
      title: title
    }, itemProps), children, canExpand ? loading ? /*#__PURE__*/React.createElement(Icon, {
      className: prefix + "cascader-menu-icon-right " + prefix + "cascader-menu-icon-loading",
      type: "loading"
    }) : /*#__PURE__*/React.createElement(Icon, {
      className: prefix + "cascader-menu-icon-right " + prefix + "cascader-menu-icon-expand",
      type: "arrow-right"
    }) : null);
  };
  return CascaderMenuItem;
}(Component);
CascaderMenuItem.menuChildType = 'item';
CascaderMenuItem.propTypes = {
  prefix: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  expanded: PropTypes.bool,
  canExpand: PropTypes.bool,
  menu: PropTypes.any,
  expandTriggerType: PropTypes.oneOf(['click', 'hover']),
  onExpand: PropTypes.func,
  onFold: PropTypes.func,
  checkable: PropTypes.bool,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  checkboxDisabled: PropTypes.bool,
  onCheck: PropTypes.func,
  children: PropTypes.node
};
export { CascaderMenuItem as default };